import { CreatablePhoneSelect, IOption } from '@r1-frontend/ui-react/components/select/creatableSelect';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import * as ST from './styled';

export const handleInputValue = -1;

interface IProps {
    options: IOption[],
    value: IOption | undefined,
    onChange: (option: IOption) => void,
    inputValue: string,
    createValue: number,
    createLabel: string,
    onInputChange: (option: IOption) => void,
}

const PhoneForm = ({ ...props }: IProps): JSX.Element => (
    <ST.Wrapper>
        <Paragraph4 $smaller>Ваш номер телефона</Paragraph4>
        <ST.ForWrapper>
            <CreatablePhoneSelect masked {...props}/>
        </ST.ForWrapper>
    </ST.Wrapper>
);

export default PhoneForm;
